import script from "./MessageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageView.vue?vue&type=script&setup=true&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=c3ee81ee&lang=scss"

const __exports__ = script;

export default __exports__